
export default {
  data() {//Declaracao de variaveis
    return {
      validacao: {
        cpfCnpj: [
          v => !!v || this.$t("messages.validacao.cpfCnpjVazio"),
          v => (v && this.validaCpfCnpj(v)) || this.msg,
        ],

        cpf: [
          v => !!v || this.$t("messages.validacao.cpfVazio"),
          v => (v && this.validaCpf(v)) || this.$t("messages.validacao.cpfInValido")
        ],

        cnpj: [
          v => !!v || this.$t("messages.validacao.cnpjVazio"),
          v => (v && this.validaCnpj(v)) || this.$t("messages.validacao.cnpjInValido")
        ],

        email: [
          v => !!v || this.$t("messages.validacao.emailVazio"),
          v => (v && this.validaEmail(v)) || this.$t("messages.validacao.emailInValido")
        ],

        emailValid: [
          v => (this.validaEmail(v)) || this.$t("messages.validacao.emailInValido")
        ],

        campoObrigatorio: [v => !!v || this.$t("messages.validacao.campoObrigatorio")],

        validAlphaNumeric: [
          v => !!v || this.$t("messages.validacao.campoObrigatorio"),
          v => this.validAlphaNumeric(v) || this.$t("messages.validacao.alphaNumeric")],

        validAlphaNumericCaracter: [
            v => !!v || this.$t("messages.validacao.campoObrigatorio"),
            v => this.validAlphaNumericCaracter(v) || this.$t("messages.validacao.alphaNumericCaracter")],

        campoTelefone: [
          v => !!v || this.$t("messages.validacao.campoObrigatorio"),
          v => this.validQtd(v, 14) || this.$t("messages.validacao.telefoneInValido")
        ],

        campoCelular: [
          v => !!v || this.$t("messages.validacao.campoObrigatorio"),
          v => this.validQtd(v, 15) || this.$t("messages.validacao.celularInValido")
        ],
        campoCelularEst: [
          v => !!v || this.$t("messages.validacao.campoObrigatorio"),
          v => this.validQtd(v, 13) || this.$t("messages.validacao.celularInValido")
        ],
        campoFax: [
          v => this.validQtd(v, 14) || this.$t("messages.validacao.faxInValido")
        ],

        campoTelefoneAdicional: [
          v => this.validQtd(v, 14) || this.$t("messages.validacao.telefoneAdicionalInvalido")
        ],

        campoCep: [
          v => !!v || this.$t("messages.validacao.campoObrigatorio"),
          v => this.validQtd(v, 10) || this.$t("messages.validacao.cepInValido")
        ],

        campoRG: [
          v => !!v || this.$t("messages.validacao.campoObrigatorio")         
        ],

        finalidadeEmpresa: [
          // finalidade empresa => "Sem fins lucrativos" === 0, "Com fins lucrativos" === 1
          v => (v != null) || this.$t("messages.validacao.campoObrigatorio"),
        ],

        codigoCredor: [
          v => !!v || this.$t("messages.validacao.campoObrigatorio"),
          v => v.length === 10 || this.$t("messages.validacao.codigoCredorInvalido")
        ]
      },
      msg: this.$t("messages.validacao.cpfCnpjVazio"),
    }
  },
  methods: {//Declaracao de todos os metodos

    validaCpfCnpj(cpfCnpj) {

      cpfCnpj = cpfCnpj.replace(/[./-]/g, '');


      if (cpfCnpj.length < 11) {
        this.msg = this.$t("messages.validacao.cpfCnpjInValido")
        return false;
      } else {

        if (cpfCnpj.length === 11) {
          this.msg = this.$t("messages.validacao.cpfInValido");
          return this.validaCpf(cpfCnpj)

        } else {
          this.msg =  this.$t("messages.validacao.cnpjInValido")
          return this.validaCnpj(cpfCnpj)

        }

      }

    },

    validaCpf(cpf) {
      var regexCpf = /^(([0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2})|([0-9]{11}))$/;
      if(regexCpf.test(cpf))
        return this.testCPF(cpf);
      else
        return false;
    },

    validaCnpj(cnpj) {
    // 1. Garantia de string e tratamento de null/undefined
    if (!cnpj) return false;
    
    // 2. Converte para string, remove formatação e normaliza
    const cnpjLimpo = cnpj
      .toString()
      .replace(/[^A-Z0-9]/gi, '')
      .toUpperCase()
      .trim();
    
    // 3. Validação básica de tamanho
    if (cnpjLimpo.length !== 14) return false;
    
    // 4. Valida formato: 12 primeiros alfanuméricos, 2 últimos numéricos
    for (let i = 0; i < 12; i++) {
      if (!/[A-Z0-9]/.test(cnpjLimpo[i])) return false;
    }
    for (let i = 12; i < 14; i++) {
      if (!/[0-9]/.test(cnpjLimpo[i])) return false;
    }
    
    // 5. Rejeita sequências com 12 caracteres iguais
    if (/^([A-Z0-9])\1{11}$/.test(cnpjLimpo.substring(0, 12))) return false;
    
    // 6. Converte caracteres para valores numéricos (ASCII - 48)
    const valores = new Array(14);
    for (let i = 0; i < 12; i++) {
      valores[i] = cnpjLimpo.charCodeAt(i) - 48;
    }
    valores[12] = parseInt(cnpjLimpo[12], 10);
    valores[13] = parseInt(cnpjLimpo[13], 10);
    
    // 7. Cálculo do 1º DV (Módulo 11)
    const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let soma = valores.slice(0, 12).reduce((acc, val, idx) => acc + val * pesos1[idx], 0);
    let resto = soma % 11;
    const dv1 = resto < 2 ? 0 : 11 - resto;
    
    if (dv1 !== valores[12]) return false;
    
    // 8. Cálculo do 2º DV (Módulo 11)
    const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    soma = valores.slice(0, 13).reduce((acc, val, idx) => acc + val * pesos2[idx], 0);
    resto = soma % 11;
    const dv2 = resto < 2 ? 0 : 11 - resto;
    
    return dv2 === valores[13];
  },

    validaEmail(email) {
      if (email == null || email === "" )
        return true

      var regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regexEmail.test(email);
    },
    validAlphaNumeric: function(value){
      var re = /(?=.*[a-zA-Z])[a-zA-Z0-9]{6,8}/g; 

      if (!!value && (value.length < 6 || value.length > 8))
        return false;     

			return re.test(value);
		},    
    validAlphaNumericCaracter: function(value){
      var ca = /^(?=.*[0-9])(?=.*[a-zA-Z!@#$%^&*()_+\-=[\]{};:"\\|,.<>/?~])[^']{6,8}$/;
  
      if (!!value && (value.length < 6 || value.length > 8))
          return false;
  
      return ca.test(value);
  },
    validQtd: function(value, qtd){
      return !(!!value && value.length < qtd);
		},
    testCPF: function(cpf){
      var Soma = 0;
      var Resto = 0;
      var i = 0;

      // Garante que o valor é uma string
      cpf = cpf.toString();

      // Remove caracteres inválidos do valor
      cpf = cpf.replace(/[^\d]+/g, '');

      if (cpf === "00000000000" || cpf === "11111111111"
      || cpf === "22222222222" || cpf === "33333333333"
      || cpf === "44444444444" || cpf === "55555555555"
      || cpf === "66666666666" || cpf === "77777777777"
      || cpf === "88888888888" || cpf === "99999999999") return false;

      for (i=1; i<=9; i++) Soma = Soma + parseInt(cpf.substring(i-1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11))  Resto = 0;
      if (Resto !== parseInt(cpf.substring(9, 10)) ) return false;

      Soma = 0;
      for (i = 1; i <= 10; i++) Soma = Soma + parseInt(cpf.substring(i-1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11))  Resto = 0;
      if (Resto !== parseInt(cpf.substring(10, 11) ) ) return false;
      return true;
    },
    testCNPJ: function(cnpj)
    {
       // Garante que o valor é uma string
       cnpj = cnpj.toString();

       // Verifica o tamanho (14 caracteres)
       if (!cnpj || cnpj.length !== 14) return false;
 
       // Valida formato: 12 primeiros alfanuméricos (A-Z ou 0-9), 2 últimos numéricos (0-9)
       for (let i = 0; i < 12; i++) {
         if (!/[A-Z0-9]/.test(cnpj[i]) || (/[A-Z]/.test(cnpj[i]) && cnpj[i] !== cnpj[i].toUpperCase())) {
           return false;
         }
       }
       for (let i = 12; i < 14; i++) {
         if (!/[0-9]/.test(cnpj[i])) return false;
       }
 
       // Verifica se todos os 12 primeiros caracteres são iguais
       let allSame = true;
       for (let i = 1; i < 12; i++) {
         if (cnpj[i] !== cnpj[0]) {
           allSame = false;
           break;
         }
       }
       if (allSame) return false;
 
       // Converte caracteres para números (ASCII - 48 para letras)
       const cnpjNumbers = Array(14);
       for (let i = 0; i < 12; i++) {
         cnpjNumbers[i] = /[0-9]/.test(cnpj[i]) ? parseInt(cnpj[i]) : cnpj.charCodeAt(i) - 48;
       }
       cnpjNumbers[12] = parseInt(cnpj[12]);
       cnpjNumbers[13] = parseInt(cnpj[13]);
 
       // Cálculo do primeiro dígito verificador
       const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
       let sum = 0;
       for (let i = 0; i < 12; i++) {
         sum += cnpjNumbers[i] * weights1[i];
       }
       const remainder = sum % 11;
       const firstCheckDigit = remainder < 2 ? 0 : 11 - remainder;
 
       if (firstCheckDigit !== cnpjNumbers[12]) return false;
 
       // Cálculo do segundo dígito verificador
       const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
       sum = 0;
       for (let i = 0; i < 13; i++) {
         sum += cnpjNumbers[i] * weights2[i];
       }
       const secondCheckDigit = (sum % 11) < 2 ? 0 : 11 - (sum % 11);
 
       return secondCheckDigit === cnpjNumbers[13];
    }
  }
};
